import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { Configuration } from '../../core/configuration/configuration';
import { SessionHelper } from '../../core/helper/sessionHelper';
import { A3LCompany } from '../../core/models/a3LCompany.model';
import { A3LEmployeeCustomDataUpdateRequest } from '../../core/models/a3LEmployeeCustomDataUpdateRequest.model';
import { BolsaVacaciones } from '../../core/models/bolsaVacaciones.model';
import { ConveniosEmpresa } from '../../core/models/conveniosEmpresa.model';
import { DatosCalculoBolsaVacaciones } from '../../core/models/datosCalculo.model';
import { Empleado } from '../../core/models/empleado.model';
import { PeriodosBolsaVacacionesModel } from '../../core/models/periodosBolsaVacaciones.model';
import { A3LEmployeeService } from '../../core/services/a3LEmployee.service';
import { ConveniosEmpresaService } from '../../core/services/conveniosEmpresa.service';
import { EmpleadoService } from '../../core/services/empleado.service';

@Component({
  selector: 'app-asignar-tipo-calculo-empleado',
  templateUrl: './asignar-tipo-calculo-empleado.component.html',
  styleUrls: ['./asignar-tipo-calculo-empleado.component.scss'],
  providers: [EmpleadoService, ConveniosEmpresaService,A3LEmployeeService]
})
export class AsignarTipoCalculoEmpleadoComponent implements OnInit {


  @ViewChild('gridPersonas', { static: false }) dataGrid: DxDataGridComponent;

  panelIcon = 'user-tag'; // material icon
  panelTitle = 'Asignar tipo cálculo';
  panelDescription = '';
  loading = false;

  empleados: Empleado[] = new Array<Empleado>();
  periodos: PeriodosBolsaVacacionesModel[] = new Array<PeriodosBolsaVacacionesModel>();

  companySelectedAgreementValue: string;
  companySelectedAgreements: ConveniosEmpresa[];
  companies: A3LCompany[] = new Array<A3LCompany>();
  calculos: DatosCalculoBolsaVacaciones [] = new Array<DatosCalculoBolsaVacaciones>();
  calculoSeleccionado: string = "";
  selectedCompany: number;
  clearValue: boolean = false;

  constructor(
    private empleadoService: EmpleadoService,
    protected employeeService: A3LEmployeeService,
    protected _conveniosEmpresaService: ConveniosEmpresaService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _sessionHelper: SessionHelper,
    protected _messageDialog: MessageDialog) {
      this.selectedCompany = this._sessionHelper.LastCompanySelectedBolsaVacaciones;
      this.getAgreements();
    }

  ngOnInit() {
    setTimeout(() => {
      if(this.selectedCompany){
        this.onSearch();
      }
    }, 60);
  }

  getGridDataSource(){
    this.empleadoService.getAllModelsByCompany(this.selectedCompany.toString()).subscribe((response: Empleado[]) => {
      if (response){
        this.empleados = response;
      }
    });
  }

  getAgreements() {
    if(!this.selectedCompany)
      return;

      this._conveniosEmpresaService.getAllModels(this.selectedCompany).subscribe(convenios => {
        this.companySelectedAgreements = convenios ?? new Array<ConveniosEmpresa>();
      },
        error => {
          console.error(error);
      });
  }

  onCompanySelecteChanged(){
    this.getAgreements();
  }

  onSelectedAgreementsChanged(event){
    // console.log(event);
    this.companySelectedAgreementValue = event;
    const agreement = this.companySelectedAgreements.find(x => x.Id == event);
    if (agreement)
      this.calculos = agreement.Calculos;
    else
      this.calculos = new Array<DatosCalculoBolsaVacaciones>();
  }

  onSearch() {
    this._sessionHelper.LastCompanySelectedBolsaVacaciones = this.selectedCompany;
    this.getGridDataSource();
  }

  onClickEdit(row: BolsaVacaciones) {
      this._router.navigate([Configuration.editPath, row.Id], {
         relativeTo: this._activatedRoute,
         state: row
      });
  }

  onEditorPreparing(e): void {
    if (e.parentType === 'searchPanel') {
        e.editorOptions.stylingMode = 'underlined';
    }
  }

  btnAsignarClick() {
    const selectedRows = this.dataGrid.instance.getSelectedRowsData();

    const request = new A3LEmployeeCustomDataUpdateRequest();
    request.employees = new Array<string>();

    if(selectedRows && selectedRows.length > 0 && this.calculoSeleccionado)
    {
      selectedRows.forEach((employee: Empleado) => {
        request.employees.push(employee.A3LEmployeeId);
      });

      const calculo =this.calculos.find(x=> x.Id == this.calculoSeleccionado);

      if(!calculo)
        return;

      request.customDataValue = this.clearValue ? "" : calculo.ValorCampoAmpliacionEmpleado;
      request.elementName = calculo.NombreCampoAmpliacionEmpleado;
      request.templateName = calculo.NombrePlantillaCampoAmpliacion;

      this.loading = true;
      this.employeeService.putCustomData(this.selectedCompany.toString(), request)
      .subscribe(
          res=> {
              this.loading=false;
              this.dataGrid.instance.clearSelection();
              this.onSearch();
              this._messageDialog.ShowMessage("Se ha actualizado el valor asignado a los trabajadores seleccionados", "Atención");
          }
          , error => {
            this.loading = false;
            this._messageDialog.ShowException(error);
          });
    }
    else {
      this._messageDialog.ShowAlert("Debe seleccionar algún trabajador al que asignar el valor seleccionado");
    }
  }

}

